<template src="./template/index.html">

</template>
<script>
import {getWallData, getWallAmountData} from '@/services/services'
import DibbleJS from "@/dibble";
import DibbleAPI from '../../api'
import * as PATH from "path";
import $ from 'jquery';
var _ = require('lodash')

export default {
    name: 'Wall',
    data () {
        return {
            title: '',
            date: '',
            goalAmount: '',
            currentAmount: '',
            donations: [],
            showDonation: false,
            dibbleJs: DibbleJS,
            timer: '',
            slam: {
                name: '',
                amount: 0
            },
            boxScrollInterval: null,
            isScrollReachedEnd: false,
            totalHeightProgress: 300, // with height css,
            logoUrl: '',
        }
    },
    methods: {
        goToMain () {
            clearInterval(this.boxScrollInterval)
            window.location.href=`/welcome/${DibbleJS.getUID()}`;
        },
        getWallData,
        getWallAmountData,
        firstLoadWallData (uid, firstLoad) {
            if (firstLoad) {
                DibbleJS.showLoader();
            }
            this.getWallData(uid)
                .then(res => {
                    DibbleJS.hideLoader();
                    if (DibbleAPI.isResponseSuccess(res.data)) {
                        this.title = res.data.title
                        this.date = res.data.date
                        this.goalAmount = res.data.goal_amount
                        this.currentAmount = res.data.current_amount
                        this.donations = res.data.donations
                        this.logoUrl = res.data.fund_logo

                        let initScrollHeight = 0;
                        let thiz = this;

                        let element = document.getElementById("boxesID");
                        if (!element)
                        {
                            setTimeout(() => {
                                thiz.firstLoadWallData(thiz.$route.params?.uid, false);
                            }, 3000);
                            return;
                        }

                        $(element).stop().animate({scrollTop: 0}, 'fast', 'swing');

                        if (element.scrollHeight < 730)
                        {
                            setTimeout(() => {
                                thiz.firstLoadWallData(thiz.$route.params?.uid, false);
                            }, 3000);
                            return;
                        }

                        setTimeout(() => {
                            this.boxScrollInterval = setInterval(() => {
                                if (element) {
                                    initScrollHeight += 1;
                                    element.scrollTop = (initScrollHeight);
                                    if (initScrollHeight >= (element.scrollHeight - 730)) {
                                        clearInterval(thiz.boxScrollInterval);
                                        setTimeout(() => {
                                            thiz.firstLoadWallData(thiz.$route.params?.uid, false);
                                        }, 2000);
                                    }
                                }
                            }, 40);
                        }, 2000);
                    } else {
                        DibbleJS.toastErrorMessage(res.data.message)
                        this.$router.push(PATH.SORRY)
                        setTimeout(() => {
                            this.firstLoadWallData(this.$route.params?.uid, false);
                        }, 3000);
                    }
                })
                .catch(e => {
                    DibbleJS.hideLoader();
                    DibbleJS.toastErrorMessage(e.toString());
                    setTimeout(() => {
                        this.firstLoadWallData(this.$route.params?.uid, false);
                    }, 3000);
                })
        },
        callInterValGetAmountData () {
            this.timer = setInterval(() => {
                const uid = this.$route.params?.uid
                this.getWallAmountData(uid)
                    .then(res => {
                        if (DibbleAPI.isResponseSuccess(res.data)) {
                            if (!_.isEmpty(res.data.slam)) {
                                this.slam = res.data.slam
                                this.showDonation = true
                            }

                            this.goalAmount = res.data.goal_amount
                            this.currentAmount = res.data.current_amount
                        }
                    })
                    .catch(() => {
                        this.showDonation = false
                    })
            }, [10000])
        },
        firstLoadWallAmountData() {
            const uid = this.$route.params?.uid
            this.getWallAmountData(uid)
                .then(res => {
                  if (DibbleAPI.isResponseSuccess(res.data)) {
                    this.goalAmount = res.data.goal_amount
                    this.currentAmount = res.data.current_amount
                  }

                  if (!this.timer) {
                    this.callInterValGetAmountData();
                  }
                })
                .catch(() => {
                  this.showDonation = false
                })
        },
      formatCurrency(number) {
        return typeof number === 'number'
          ? number.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
          : 0
      },
    },
    created () {
        const uid = this.$route.params?.uid
        if (!uid) {
            this.$router.push(PATH.SORRY)
        } else {
            this.firstLoadWallData(uid, true);
            this.firstLoadWallAmountData();
        }
    },
    destroyed () {
        clearInterval(this.timer)
    },
    computed: {
        findPercentCollection () {
            const perHeightWithPercent = 1200
            let currentPercentage = (this.currentAmount / this.goalAmount) * 100
            if (currentPercentage < 50 || currentPercentage === 100) {
              currentPercentage += 10;
            } else {
              currentPercentage -= 10
            }

            return  currentPercentage / 100 * perHeightWithPercent
        },
      options() {
        if (this.goalAmount) {
          const space = this.goalAmount / 5
          const ops = []
          for (let i = 0; i <= 5; i++) {
            ops.push(i * space)
          }
          return ops
        }
        return []
      },
      heightProgress() {
        if (this.goalAmount && this.currentAmount) {
          if (this.currentPercent >= 112) {
            return this.totalHeightProgress + 60
          }

          const percent = this.currentAmount / this.goalAmount


          return percent * this.totalHeightProgress
        }

        return 0
      },

        currentPercent () {
            return (this.goalAmount && this.currentAmount) ? ((this.currentAmount / this.goalAmount) * 100).toFixed(0) : 0
        },
    },
    watch: {
        showDonation (value) {
            if (value) {
                setTimeout(() => {
                    $('.custom-modal-backdrop, #Modal1').fadeOut(500);
                    setTimeout(() => {
                      this.showDonation = false
                    }, 500)

                }, 6000)
            }
        },
    }
}
</script>
<style lang="scss">
  img.header-left-logo {
    width: auto;
    height: 86px;
  }
  .disabled-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 1000;
  }
  .header-middle-title {
    font-family: 'Rochester' !important;
    font-size: 72px !important;
  }
  .header-date {
    font-size: 20px;
    font-weight: 700;
    margin-top: 10px;
    color: #05cfff !important;
  }
  .c-header {
    height: 88px;
    background-color: #011443;
  }
  .c-birthday {
    font-family: 'Rochester', sans-serif;
    font-size: 32px;
  }
  .c-circle {
    width: 190px;
    height: 190px;
    border-radius: 2000px;
    border: 10px solid #425480;
    background: #011443;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.25);
    position: relative;
    z-index: 10;
  }
  .c-price {
    font-size: 28px;
    color: white;
    font-weight: 600;
  }
  .c-total {
    color: #6ecbf2;
    margin-top: -10px;
  }
  .c-progress {
    width: 105px;
    height: 422px;
    border-radius: 2000px;
    background: #425480;
    transform: translateY(65px);
    position: relative;
    padding: 10px;
  }
  .c-progress-content {
    background: #273863;
    height: 100%;
    border-radius: 2000px;
  }
  .c-progress-ratio {
    position: absolute;
    left: 0;
    transform: translateX(-110%);
    bottom: 55px;
    text-align: right;
    color: #fff;
    opacity: 0.4;
    font-weight: 600;
    top: 45px;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
  }
  .c-line {
    background-color: #69d581;
    margin-top: -2px;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .c-line-content {
    bottom: 40px;
    max-height: 105%;
  }

  .c-donations {
    background-image: url('~@/assets/images/wall-img1.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: top right;
    height: 100%;
  }
  .c-donate {
    color: #fff;
    width: 206px;
    height: 224px;
    padding: 32px;
    border-radius: 16px;
    background: #1b53a8;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    text-align: center;
    gap: 16px;
  }
  .c-donate img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
  }
  .c-donate .title {
    font-weight: 600;
  }
  .c-donate .donated {
    color: #cccccc;
  }
  .c-donate .price {
    font-weight: 600;
  }
  @media screen and (max-width: 399.95px) {
    .c-header {
      padding: 16px !important;
      height: auto;
    }
    .c-header img {
      width: 150px;
    }
    .c-birthday {
      font-size: 20px;
      margin-left: unset !important;
    }
    .c-donations .c-donate {
      margin-top: 0 !important;
      margin-left: 0 !important;
      width: auto !important;
      height: 100% !important;
      padding: 12px;
    }
    .c-donations .col-6 {
      margin-bottom: 20px;
    }
  }

  #waveShape {
    animation-name: waveAction;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-duration: 1.5s;
    width:300px;
    height: 100%;
    fill: #69d581;
  }
  @keyframes waveAction {
    0% {
      transform: translate(-150px, 0);
    }
    100% {
      transform: translate(0, 0);
    }
  }
</style>
